module.exports = __webpack_public_path__ + "img/Solvay_80X30.ee2289fc.png";